import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { FIELD_CSS } from '@abgen/render/styles';
import { installFontFaces } from './fonts/fontFaces.js';
import './styles.css';
import './workspace.css';

installFontFaces();

// Felder sehen im Editor aus wie im Druck: derselbe Stil aus @abgen/render.
const fieldStyles = document.createElement('style');
fieldStyles.dataset.abgen = 'fields';
fieldStyles.textContent = FIELD_CSS;
document.head.append(fieldStyles);

const container = document.getElementById('app');
if (!container) {
  throw new Error('Container #app fehlt im HTML');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Service Worker für das digitale Arbeitsblatt (Phase 7.1). Er wird nur im
 * Betrieb registriert; in der Entwicklung stört er das Neuladen.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
